import React from 'react'
import { cn } from '@/lib/utils'

interface HeritageBadgeProps {
  children?: React.ReactNode
  invert?: boolean
  className?: string
}

// Default badge text confirmed by Ryan 2026-05-19: Front Range is
// Colorado's longest-running cargo bike shop (and Boulder County's
// longest-running e-bike shop — see AboutHero copy). Pages that
// override the children prop with their own copy can do so explicitly.
export function HeritageBadge({
  children = "Colorado's Longest-Running Cargo Bike Shop",
  invert = false,
  className,
}: HeritageBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-2.5 pl-3 pr-4 py-2 rounded-full",
        "text-xs font-semibold uppercase tracking-[0.06em] whitespace-nowrap",
        "shadow-sm",
        invert
          ? "bg-white/[0.08] text-background border border-secondary/35"
          : "bg-card text-primary border border-border",
        className
      )}
    >
      {/* Pulsing dot */}
      <span aria-hidden="true" className="relative inline-block w-2.5 h-2.5">
        <span className="absolute inset-0 rounded-full bg-secondary animate-ping opacity-75" />
        <span className="absolute inset-0 rounded-full bg-secondary" />
      </span>
      {children}
    </span>
  )
}
